export const HIGHEST_LOSER = "HIGHEST_LOSER";
export const HIGHEST_LOSER_STREAM = "HIGHEST_LOSER_STREAM";
